<script>
  let className = '';

  export { className as class };
  export let data;
  export let columns;
  export let fixedHeader = true;
</script>

<table
  cellspacing="0"
  cellpadding="0"
  width="100%"
  class={className}
>
  <thead class:table-fixed-head={fixedHeader}>
    <tr>
      {#each columns as col}
        <slot
          name="col"
          col={col}
        />
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each data as row, index}
      <slot
        name="row"
        row={row}
      />
    {/each}
    <slot />
  </tbody>
</table>

<style lang="scss">
  :global(.table-fixed-head th) {
    position: sticky;
    top: 0;
    background-color: #fafafa !important;
    z-index: 1;
    padding: 4px 3px;

    font-size: 0.625rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    line-height: 1.6;
    color: #656d77;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid rgba(101, 109, 119, 0.16) !important;
  }
  :global(th) {
    white-space: nowrap;
    vertical-align: middle;
  }
  :global(td) {
    padding: 3px;
    color: #212529;
  }
</style>
